import React from 'react';
import { LayersIcon, HeartPulseIcon, CalendarDaysIcon, PrinterIcon } from 'lucide-react';
import { kitContents, kitHighlight } from '../data/kit';
const icons = {
  layers: LayersIcon,
  heart: HeartPulseIcon,
  calendar: CalendarDaysIcon,
  printer: PrinterIcon
};
export function KitContentsSection() {
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-94" data-mp="2a84x5gzvy6bn">
      <div className="max-w-5xl mx-auto" data-id="element-95" data-mp="2f6exs74dpz4n">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text text-center mb-16" data-id="element-96" data-mp="2f5n8tf5aeznc">
          ¿Qué contiene Pilates Listo 360?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-97" data-mp="2nyqirdgq4ud8">
          {kitContents.map(item => {
          const Icon = icons[item.icon];
          return <article key={item.title} className="bg-brand-panel rounded-3xl p-8 text-center border border-brand-creamDark/60 shadow-sm flex flex-col items-center" data-id="element-98" data-mp="2sx1rtlz730ue">
                <Icon className="w-8 h-8 text-brand-greenDark mb-4" aria-hidden="true" data-id="element-99" data-mp="32twn7w068l4g" />
                <h3 className="text-xl font-serif font-bold text-brand-text mb-2" data-id="element-100" data-mp="vm9nim68vuii">
                  {item.title}
                </h3>
                <p className="text-brand-gray text-sm mt-auto" data-id="element-101" data-mp="qnybc4sh97x4">{item.desc}</p>
              </article>;
        })}

          <article className="md:col-span-2 bg-brand-text rounded-3xl p-8 md:p-10 text-center shadow-sm flex flex-col items-center" data-id="element-102" data-mp="mo7hfs7nmbod">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-white mb-3" data-id="element-103" data-mp="1ecira0hojucb">
              {kitHighlight.title}
            </h3>
            <p className="text-white/75 text-sm md:text-base max-w-2xl" data-id="element-104" data-mp="19kr3tyttm4qe">
              {kitHighlight.desc}
            </p>
          </article>
        </div>
      </div>
    </section>;
}